import axios from 'axios';
import { getAccessToken } from '../Authentication/AuthenticationService';
import AppConstants from '../AppConstants';

const baseUrl = AppConstants.ACCOUNT_SERVICE_BASE_URL;
const appStateBaseUrl = AppConstants.APPLICATION_STATE_SERVICE_BASE_URL;
const E2E_DASHBOARD = 'e2e_dashboard';

export function getMe() {
  return axios.get(baseUrl + '/identity/v1/Users/me', {
    params: {
      client: AppConstants.APP_NAME
    },
    headers: {
      Authorization: 'Bearer ' + getAccessToken()
    }
  });
}

export function getUserConfig(accountKey, userKey) {
  return axios.get(appStateBaseUrl + '/applicationstateservice/state', {
    headers: {
      'X-Account-Key': accountKey,
      'X-User-Key': userKey,
      'Product-Identifier': E2E_DASHBOARD
    }
  });
}



// WEBPACK FOOTER //
// ./src/Apis/AccountServiceApi.js